// Canonical domain taxonomy — single source of truth for the frontend.
// Domains are a curated, controlled vocabulary the author picks from (max 2 per skill),
// used as the primary browse / filter axis. Optional and distinct from free-form `tags`.
// Keep this in sync with the backend copy at backend/app/domains.py.

export type Domain = { slug: string; label: string };

// "other" is the catch-all bucket and stays last.
export const DOMAINS: Domain[] = [
  { slug: "ai-ml", label: "AI & ML" },
  { slug: "development", label: "Development" },
  { slug: "cloud-devops", label: "Cloud & DevOps" },
  { slug: "data", label: "Data & Databases" },
  { slug: "testing", label: "Testing" },
  { slug: "tools", label: "Developer Tools" },
  { slug: "documentation", label: "Documentation" },
  { slug: "productivity", label: "Productivity" },
  { slug: "learning", label: "Learning" },
  { slug: "business", label: "Business & Finance" },
  { slug: "content-media", label: "Content & Media" },
  { slug: "research", label: "Research" },
  { slug: "lifestyle", label: "Lifestyle" },
  { slug: "other", label: "Other" },
];

export const MAX_DOMAINS = 2;

const LABELS = new Map(DOMAINS.map((d) => [d.slug, d.label]));

// Human label for a domain slug; falls back to the raw slug for unknown values.
export const domainLabel = (slug: string): string => LABELS.get(slug) ?? slug;
